/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AccessType } from '../../models/access-type';
import { TokenResponseModel } from '../../models/token-response-model';

export interface AuthenticationLoginLight$Params {

/**
 * Access type
 */
  accessType?: AccessType;
}

export function authenticationLoginLight(http: HttpClient, rootUrl: string, params?: AuthenticationLoginLight$Params, context?: HttpContext): Observable<StrictHttpResponse<TokenResponseModel>> {
  const rb = new RequestBuilder(rootUrl, authenticationLoginLight.PATH, 'get');
  if (params) {
    rb.query('accessType', params.accessType, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<TokenResponseModel>;
    })
  );
}

authenticationLoginLight.PATH = '/v1/Authentication/LoginLight';
